/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import styled from "styled-components";

export const ContactContainer = styled.div`

`;

export const Contact = styled.section`
    position: relative;
    width: 100%;
`;

export const IconContainer = styled.div`
    @media only screen and (min-width: 980px) {
        padding: 10rem 7rem;
    }
`;



export const FormGroup = styled.form`
    width: 100%;
    max-width: 650px;
    @media only screen and (max-width: 1045px) {
        max-width: 100%;
        margin-top: 2rem;
    }
`;

export const Span = styled.span`
    display: block;
    font-family: "Ubuntu", sans-serif;
     
    font-weight: 600;
    color: rgb(255, 130, 92);
    height: 0.775rem;
    padding: 0 0.675rem;
`;

export const ButtonContainer = styled.div`
    text-align: center;
    position: relative;
    @media only screen and (max-width: 414px) {
        padding-top: 0.75rem;
    }
`;

export const SubTitle = styled.div`
    font-size:20px;
    font-weight:600;
`
